import { render } from "./Footer.vue?vue&type=template&id=0848a3e2&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=0848a3e2&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0848a3e2"]])

export default __exports__